import ApplicationController from '../../../support/application_controller'

export default class extends ApplicationController {

  static targets = [
    ...super.targets,
    'sourceInput',
    'dateInput',
    'diabetesDateInput',
    'month',
    'year'
  ]

  prepopulate({ currentTarget = this.#selectedSourceInput() } = {}) {
    this.#updateMonth(currentTarget)
    this.#updateYear(currentTarget)
    // NOTE: logic must match
    // app/facades/consultation_note/kaelo_chronic_benefit_application/step_facade.rb #show_date_fields_for?
    if (this.hasDateInputTarget) {
      this.dateInputTarget.classList.remove('u-hide')
    }

    if (this.hasDiabetesDateInputTarget) {
      const selected = currentTarget || this.#selectedSourceInput()

      this.diabetesDateInputTarget.classList.toggle('u-hide', !selected)
    }
  }

  prepopulateDiabetes() {
    this.prepopulate()
  }

  monthTargetConnected() {
    this.#updateMonth(this.#selectedSourceInput())
  }

  yearTargetConnected() {
    this.#updateYear(this.#selectedSourceInput())
  }

  #updateMonth(code) {
    const monthData = code?.dataset.month
    this.monthTarget.value = monthData || ''
  }

  #updateYear(code) {
    const yearData = code?.dataset.year
    this.yearTarget.value = yearData || ''
  }

  #selectedSourceInput() {
    return this.sourceInputTargets.find((input) => (
      input.checkVisibility() && input.checked
    ))
  }

}
